export default "__VITE_ASSET__C1UxEZrR__"